import { SurveyTemplate } from "../../types";
import { ReactComponent as IconFavoritePoster } from "assets/svg/favorite-poster.svg";

export const favTourPoster: SurveyTemplate<{ artist?: string }> = {
  icon: <IconFavoritePoster />,
  title: "Favorite Poster Design",
  description:
    "Invite fans to give feedback on the artwork for the tour poster.",
  templateId: "favTourPoster",
  template: ({ artist }, formState) => ({
    fields: {
      description: {
        content: {
          en: "Favorite Tour Poster Design",
        },
      },
      header: {
        content: {
          en: "Pick your Favorite Tour Poster Design",
        },
      },
      body: {
        content: {
          en: `With ${artist} hitting the road, it's your chance help decide which artwork should be used on the tour posters!`,
        },
      },
      numberOfCategories: {
        content: "2",
      },
      displayedCategories: {
        content: [
          "demographics",
          "fooddrink",
          "alcohol",
          "clothing",
          "vehicle",
          "entertainment",
        ],
      },
      thankYouHeader: {
        content: {
          en: "Thanks for Your Vote",
        },
      },
      thankYouBody: {
        content: {
          en: "We'll be announcing the official tour poster soon - thanks for helping us decide!",
        },
      },
    },
    surveyQuestions: [
      {
        type: "ImageQuestion",
        actionRequired: true,
        showLabels: false,
        required: false,
        label: {
          en: "Which of these tour posters is your favorite?",
        },
      },
      {
        multiline: false,
        actionRequired: false,
        noBorder: false,
        required: true,
        label: {
          en: "Why did you vote for the poster you chose?",
        },
        type: "TextQuestion",
      },
    ],
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-tour---pos-32a6aa"
        : "pp-tour---pos-38927d",
  },
};
